<template>
	<div class="animated fadeIn">
		<b-card>
			<div class="display-table full-width mb-2">
				<strong class="card-title">{{$route.meta.label}}</strong>
			</div>
			<b-row>
				<ResponseAlert ref="response" />
				<div class="col-sm-12 mb-10">
					<b-row class="align-items-center justify-content-end">
						<b-col class="mb-2 mb-sm-0" md="3" lg="2">
							<b-form-select v-model="config.additional_params.created_by" :options="masters.contributors"></b-form-select>
						</b-col>
						<b-col class="mb-2 mb-sm-0" md="3" lg="2">
							<b-form-select v-model="config.additional_params.category_id" :options="masters.categories"></b-form-select>
						</b-col>
						<b-col md="4" lg="3">
							<div class="input-group">
								<input type="text" placeholder="Search" v-model="config.search.key" v-on:keyup.enter="get()"
									class="form-control form-control-sm" />
								<div class="input-group-prepend">
									<div class="input-group-text" v-on:click="get()">
										<i class="fa fa-search"></i>
									</div>
								</div>
							</div>
						</b-col>
					</b-row>
				</div>
				<b-col sm="12">
					<div class="table-responsive">
						<table class="table b-table">
							<thead>
								<tr>
									<th v-for="(row, key) in config.headers" :width="row.width" :key="key"
										:class="row.class">
										<a v-if="row.value" class="sort dark-font" v-on:click="sort(row.value)"
											href="javascript:void(0)">
											{{row.title}}
											<i :id="row.value" class="fa fa-sort"></i>
										</a>
										<a v-else class="sort dark-font" :id="row.value" href="javascript:void(0)">
											{{row.title}}
										</a>
									</th>
								</tr>
							</thead>
							<tbody>
								<template v-if="config.total_data">
									<tr v-for="(row, key) in config.rows" :key="key">
										<td>{{row.title}}</td>
										<td>{{moment(row.created_at).format('DD MMM YYYY HH:mm')}}</td>
										<td>{{row.category.name}}</td>
										<td>{{row.created_by.first_name}} {{row.created_by.last_name}}</td>
										<td>{{row.total_read}}</td>
										<td>
											<span :class="'badge badge-' + getClassStatus(row.status)">
												{{row.status}}
											</span>
										</td>
										<td align="center">
											<!-- <router-link :to='`/${config.uri}/${row.id}`' title="Detail"
												class="btn-action">
												<i class="fa fa-eye"></i>
											</router-link>
											<router-link :to='`/${config.uri}/edit/${row.id}`' title="Edit"
												class="btn-action">
												<i class="fa fa-pencil"></i>
											</router-link> -->
											<button @click="goToDetail(row.id)" title="Detail" class="btn-action">
												<i class="fa fa-eye"></i>
											</button>
											<button @click="goToEdit(row.id)" title="Edit" class="btn-action">
												<i class="fa fa-pencil"></i>
											</button>
											<button @click="destroy(row.id)" title="Delete" class="btn-action">
												<i class="fa fa-trash"></i>
											</button>
										</td>
									</tr>
								</template>
								<tr v-if="!config.total_data">
									<td :colspan="config.headers.length" align="center"> No data available. </td>
								</tr>
							</tbody>
							<tfoot v-if="config.total_data">
								<tr>
									<td :colspan="config.headers.length" class="no-padding">
										<div class="pull-left table-information mt-25">
											<p>Showing {{config.page}} to {{config.total_page}} of {{config.total_data}}
												entries</p>
										</div>
										<div class="pull-right pagination mt-25">
											<b-pagination @change="gotoPage" :total-rows="config.total_data"
												v-model="config.page" :per-page="config.per_page">
											</b-pagination>
										</div>
									</td>
								</tr>
							</tfoot>
						</table>
					</div>
				</b-col>
			</b-row>
		</b-card>
	</div>
</template>
<script>
	import moment from 'moment'
	import table from '@/utils/table.js'
	import api from '@/utils/api.js'
	import ResponseAlert from '@/components/response_alert';
	import { getClassStatus } from '@/utils/helpers';
	export default {
		name: 'ListArticle',
		components: {
			ResponseAlert,
		},
		data() {
			return {
				moment,
				config: {
					uri: this.$route.meta.permission.link,
					api: api.news,
					rows: [],
					total_data: 0,
					total_page: 0,
					per_page: 10,
					page: 1,
					orderby: "id",
					sort: "desc",
					additional_params: {
						category_id: '',
						created_by: '',
						is_contributor_news: true
					},
					search: {
						key: ""
					},
					headers: [{
						title: "Title",
						value: "title",
						align: "text-left",
						width: "20%",
					}, {
						title: "Date",
						value: "date",
						align: "text-left",
						width: "15%",
					},{
						title: "Category",
						value: "category_id",
						align: "text-left",
						width: "15%",
					},{
						title: "Contributor",
						value: false,
						align: "text-left",
						width: "15%",
					},{
						title: "Views",
						value: "total_read",
						align: "text-left",
						width: "10%",
					}, {
						title: "Status",
						value: "status",
						align: "text-left",
						width: "10%",
					}, {
						title: "Action",
						value: false,
						class: "text-center",
						width: "15%",
					}],
				},
				masters: {
					contributors: [
						{
							value: '',
							text: 'Contributor'
						}
					],
					categories: [
						{
							value: '',
							text: 'Category'
						}
					]
				}
			}
		},
		created() {
			const _ = this;

			// Check if there’s saved state
			const saved = localStorage.getItem('article_list_state');
			if (saved) {
				const state = JSON.parse(saved);
				_.config.page = state.page || 1;
				_.config.per_page = state.per_page || 10;
				_.config.search.key = state.search || "";
				_.config.additional_params.created_by = state.created_by || '';
				_.config.additional_params.category_id = state.category_id || '';
				localStorage.removeItem('article_list_state');
			}

			_.get();
			_.getOptionsData()
		},
		methods: {
			get() {
				table.get(this.config)
			},
			sort(orderby) {
				table.sort(this.config, orderby)
			},
			gotoPage(page) {
				table.gotoPage(this.config, page)
			},
			getClassStatus(status) {
				return getClassStatus(status);
			},
			getOptionsData() {
				const getContributor = this.$axios.get('user?orderby=id&sort=desc&per_page=10000&role_id=1&is_contributor=true')
				const getNewsCategory = this.$axios.get('news_category?orderby=id&sort=desc&per_page=10000&status=active')

				this.$axios.all([getContributor, getNewsCategory])
					.then(res => {
						res[0].data.data.rows.forEach( contributor => {
							this.masters.contributors.push({
								text: `${contributor.first_name} ${contributor.last_name}`,
								value: contributor.id
							})
						})
						res[1].data.data.rows.forEach( category => {
							this.masters.categories.push({
								text: category.name,
								value: category.id
							})
						})
					})
			},
			destroy(id) {
				const _ = this;
				_.$dialog.confirm('Are you sure want to delete this data?', {
						"okText": "Yes",
						"cancelText": "No"
					})
					.then(() => {
						_.$axios.delete(`${api.news}/${id}`)
						.then(res => {
							_.$refs.response.setResponse(res.data.message, 'success');
							_.get()
						}).catch(error => {
							_.$refs.response.setResponse(error.response.data.message, 'danger')
						})
					})
			},
			goToDetail(id) {
				this.saveListState();
				this.$router.push(`/${this.config.uri}/${id}`);
			},
			goToEdit(id) {
				this.saveListState();
				this.$router.push(`/${this.config.uri}/edit/${id}`);
			},
			saveListState() {
				localStorage.setItem('article_list_state', JSON.stringify({
					page: this.config.page,
					per_page: this.config.per_page,
					search: this.config.search.key,
					created_by: this.config.additional_params.created_by,
					category_id: this.config.additional_params.category_id
				}));
			},
		},

		computed:{
			filterChange(){
				return `${this.config.additional_params.category_id}|${this.config.additional_params.created_by}`
			}
		},
		watch: {
			filterChange() {
				this.get()
			}
		}
	}
</script>
